document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantes();
});

function initReveal() {
  var els = document.querySelectorAll('.dt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('dt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('dt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var principal = document.querySelector('[data-dt-galeria-principal]');
  var minis = document.querySelectorAll('[data-dt-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      var img = principal.querySelector('img');
      if (img && src) {
        img.setAttribute('src', src);
        img.setAttribute('alt', alt);
      }
      minis.forEach(function (m) { m.classList.remove('dt-activa'); });
      mini.classList.add('dt-activa');
    });
  });
}

function initVariantes() {
  var wrap = document.querySelector('[data-dt-variantes]');
  if (!wrap) return;
  var dataEl = document.querySelector('[data-dt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var idInput = document.querySelector('[data-dt-variant-id]');
  var precioEl = document.querySelector('[data-dt-precio]');
  var tachadoEl = document.querySelector('[data-dt-precio-tachado]');
  var botonComprar = document.querySelector('[data-dt-comprar]');
  var avisoAgotado = document.querySelector('[data-dt-agotado]');
  var botonesOpcion = wrap.querySelectorAll('[data-dt-opcion-valor]');
  var seleccion = {};

  botonesOpcion.forEach(function (btn) {
    if (btn.classList.contains('dt-activa')) {
      seleccion[btn.getAttribute('data-opcion-index')] = btn.getAttribute('data-valor');
    }
  });

  function actualizar() {
    var match = variantes.find(function (v) {
      return v.opciones.every(function (val, i) { return seleccion[i] === val; });
    });
    if (!match) return;
    if (idInput) idInput.value = match.id;
    if (precioEl) precioEl.textContent = match.precio;
    if (tachadoEl) {
      if (match.precioComparado) {
        tachadoEl.textContent = match.precioComparado;
        tachadoEl.style.display = '';
      } else {
        tachadoEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !match.disponible;
      botonComprar.textContent = match.disponible ? botonComprar.getAttribute('data-texto-normal') : botonComprar.getAttribute('data-texto-agotado');
    }
    if (avisoAgotado) avisoAgotado.style.display = match.disponible ? 'none' : '';
  }

  botonesOpcion.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var index = btn.getAttribute('data-opcion-index');
      seleccion[index] = btn.getAttribute('data-valor');
      wrap.querySelectorAll('[data-opcion-index="' + index + '"]').forEach(function (b) {
        b.classList.remove('dt-activa');
      });
      btn.classList.add('dt-activa');
      actualizar();
    });
  });
}
